import { createAction, props } from '@ngrx/store';
import { User } from '../_models';

// Azioni per l'utente corrente
export const setCurrentUser = createAction('[User] Set Current User', props<{ user: User }>());
export const setCurrentUserSuccess = createAction(
  '[User] Set Current User Success',
  props<{ user: User }>()
);
export const setCurrentUserFailure = createAction(
  '[User] Set Current User Failure',
  props<{ error: any }>()
);

export const clearCurrentUser = createAction('[User] Clear Current User');

export const updateCurrentUserSuccess = createAction(
  '[CurrentUser] Update Current User Success',
  props<{ user: User }>()
);
